import { docodeHexResponse } from "../../_common/common.utils";
import { StatusCountActionTypes } from "./status-count.types";

const INITIAL_STATE = {
  statusCount: [],
  isLoading: false,
  error: null,
  allAgentList: null,
  allAgentListStatus: "",
  stausCountList: [],
  stausCountStatus: "",
};

const statusCountReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case StatusCountActionTypes.FETCH_STATUS_COUNT_SUCCESS:
      return {
        ...state,
        stausCountList: docodeHexResponse(action.payload, "StatusCountKey"),
        stausCountStatus: action.payload,
      };
    case StatusCountActionTypes.FETCH_STATUS_COUNT_FAILURE:
      return {
        ...state,
        stausCountList: [],
        stausCountStatus: action.payload,
      };
    case StatusCountActionTypes.FETCH_STATUS_COUNT_CHANGED:
      return {
        ...state,
        stausCountStatus: "",
      };
    case StatusCountActionTypes.FETCH_AGENTS_SUCCESS:
      return {
        ...state,
        allAgentList: docodeHexResponse(action.payload, "GetAllLeadSourceKey"),
        allAgentListStatus: "Success",
      };
    case StatusCountActionTypes.FETCH_AGENTS_FAILURE:
      return {
        ...state,
        allAgentList: null,
        allAgentListStatus: "Failure",
      };
    case StatusCountActionTypes.FETCH_AGENTS_CHANGED:
      return {
        ...state,
        allAgentListStatus: "",
      };
    default:
      return state;
  }
};

export default statusCountReducer;
